module.exports = [{"type":"hash","text":"Access"},{"type":"normal","text":"the base URL of Websocket Market Data ：wss://open-api-cswap-ws.bingx.com/market"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/websocket/introduce/01_connect.json
// module id = lyY+
// module chunks = 3